import React, {useContext, useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import {Context} from "../../index";
import {Chart} from "react-chartjs-2";
import "chart.js/auto";
import {pieChartData} from "../../utils/utils";

const PieChart = ({allMarks, days, today}) => {
    const {userStore} = useContext(Context);
    const [data, setData] = useState([0, 0, 0, 0, 0]);

    useEffect(() => {
        const newData = pieChartData(allMarks, days, new Date(today))
        setData(newData);
    }, [days, userStore.theme]);

    return (
        <>
            {JSON.stringify(data) !== "[0,0,0,0,0]" ? <Chart
                type="pie"
                data={{
                    labels: ["5", "4", "3", "2", "1"],
                    datasets: [{
                        label: 'Количество',
                        data: data,
                        backgroundColor: userStore.theme === "light" ? [
                            'rgb(0, 210, 0)',
                            'rgb(255, 210, 0)',
                            'rgb(255, 130, 0)',
                            "rgb(255, 0, 0)",
                            "black"
                        ] : [
                            '#2ac33d',
                            '#ffb300',
                            '#ff6400',
                            "#ff0011",
                            "black"
                        ],
                        hoverOffset: 7,
                        borderColor: userStore.theme === "light" ? "white" : "#272727"
                    }]
                }}
                options={{
                    plugins: {
                        legend: {
                            position: "bottom",
                            labels: {
                                generateLabels(chart) {
                                    const dataset = chart.data.datasets[0];
                                    return chart.data.labels.map((label, i) => {
                                        const value = dataset.data[i];
                                        const percentage = ((value / data.reduce((a, b) => a + b, 0)) * 100).toFixed(1);
                                        return {
                                            text: `${label} – ${percentage}%`,
                                            fillStyle: dataset.backgroundColor[i],
                                            strokeStyle: userStore.theme === "dark" ? "white" : "gray",
                                            hidden: !chart.getDataVisibility(i),
                                            index: i,
                                            fontColor: userStore.theme === "dark" ? "white" : "black",
                                        };
                                    });
                                }
                            }
                        }
                    }
                }}
            /> : <div className="no-estimatesBlock">Оценок не получено за последние {days} дней</div>}
        </>
    );
};

export default observer(PieChart);